import React from "react";
import { PageType, useSdkContext } from "~/components/contexts";
import { useGA4CommonParameters } from "~/components/rosetta/hooks";
import { SubscriptionButton } from "~/components/rosetta/subscription-button/styles";
export const SubscribeButton = ({
  className,
  location = "masthead"
}) => {
  const {
    config,
    currentPageType,
    handleTrackGA,
    handleTrackGA4,
    handleTrackGTM,
    handleTrackMixPanel
  } = useSdkContext();
  const {
    computeGA4CommonParameters
  } = useGA4CommonParameters();
  return /*#__PURE__*/React.createElement(SubscriptionButton, {
    className: className,
    onClick: () => {
      handleTrackMixPanel({
        name: "Subscription Entry Point",
        property: {
          Location: (() => {
            switch (location) {
              case "footer":
                return "Homepage Footer";
              case "print-button":
                return "Print Icon Pop-up";
              case "masthead":
                return currentPageType === PageType.Article ? "Article Masthead" : "Homepage Masthead";
            }
          })()
        }
      });
      const gaEvent = {
        action: (() => {
          switch (location) {
            case "footer":
              return "Subscription Entry Point/Footer";
            case "print-button":
              return "Subscription Entry Point/Print Icon Pop-up/Click Subscribe";
            case "masthead":
              return currentPageType === PageType.Article ? "Subscription Entry Point/Article Page Masthead" : "Subscription Entry Point/Masthead";
          }
        })(),
        category: "Subscription Entry Point",
        label: window.location.href
      };
      handleTrackGTM({
        event: "subscribe-button",
        tracking: gaEvent
      });
      handleTrackGA(gaEvent);
      handleTrackGA4({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "subscribe",
          trigger_point: (() => {
            switch (location) {
              case "footer":
                switch (currentPageType) {
                  case PageType.Article:
                    return "article footer";
                  case PageType.Section:
                    return "section footer";
                  case PageType.Homepage:
                    return "homepage footer";
                  default:
                    return "footer";
                }
              case "masthead":
                return currentPageType === PageType.Article ? "article masthead" : "masthead";
              case "print-button":
                return "print article";
            }
          })()
        },
        subcategory: "entry_point"
      });
      window.location.href = config.subscribe.host;
    },
    "data-qa": "subscribe-button"
  }, "Subscribe");
};
SubscribeButton.displayName = "SubscribeButton";